<template>
  <highcharts
    v-if="loaded"
    :options="chartOptions"
  />
  <v-progress-circular
    v-else
    indeterminate
    color="black"
    size="80"
    width="2"
    class="mb-5"
    style="margin-left:50%"
  />
</template>

<script>

import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import HighchartsNoData from 'highcharts/modules/no-data-to-display';
HighchartsNoData(Highcharts);
More(Highcharts);
import PredicoesBaixasService from '@/services/PredicoesBaixasService';
import 'dayjs/locale/pt';

export default {
  name: 'GraficoBoxPlotPredicao',

  props: {
    idPredicao: {
      type: Number
    },
    variavelValor: {
      type: String
    }
  },

  data() {
    return {
      dataBox: [],
      categories: [],
      loaded: false
    };
  },


  computed: {

    seriesColor: function () {
      switch(this.variavelValor) {
      case 'voc':
        return '#96CAF1';
      case 'voc residual':
        return '#F7C6BB';
      case 'vnr':
        return '#4CAF50';
      case 'vnr residual':
        return '#FFCC66';
      default:
        return '#353535';
      } 
    },

    chartOptions: function () {
      return {
        chart: {
          type: 'boxplot',
          zoomType: 'y'
        },
        title: {
          text: ''
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: this.categories,
          title: {
            text: 'Tucagem'
          }
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        series: [{
          name: 'Observações',
          color: this.seriesColor,
          data: this.dataBox,
          tooltip: {
            headerFormat: '<em>TUC {point.key}</em><br/>'
          }
        } 
        ],
        lang: {
          noData: 'Não há dados'
        },
        noData: {
          style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
          }
        }
      };
    }
  },

  mounted(){
    this.getDataPredicaoBoxplot();
  },

  methods: {
    getDataPredicaoBoxplot() {
      PredicoesBaixasService.getPredicaoBoxPlot(this.idPredicao, this.variavelValor)
        .then(response => {
          var aux = [];
          response.data.box.forEach(element => {
            aux.push(parseFloat(element.btg_vnr_max));
            aux.push(parseFloat(element.btg_vnr_q3));
            aux.push(parseFloat(element.btg_vnr_med));
            aux.push(parseFloat(element.btg_vnr_q1));
            aux.push(parseFloat(element.btg_vnr_min));

            this.dataBox.push(aux.reverse());
            
            this.categories.push(element.btg_tucagem);

            aux = [];
          });

          this.loaded = true;
        })
        .catch(error => console.log(error));
    }
  }
};
</script>